import React, { useState } from 'react';

import { BaseDropdownOption } from '../../../../common/Dropdown';
import { useTeamMembers } from '../../../../hooks/useTeamMembers';
import { IndividualViewDropdown } from '../../components/IndividualViewDropdown';
import { SprintTimeline } from '../../components/SprintTimeline';
import { TeamMemberSelector } from '../../components/TeamMemberSelector';
import { individualViewTimePeriodOptions } from '../../constants';
import {
  SelectedMemberProvider,
  useSelectedMember,
} from '../../contexts/SelectedMemberContext';
import { SprintProvider } from '../../contexts/SprintContext';

function IndividualViewContent(): JSX.Element {
  const { selectedMember, setSelectedMember } = useSelectedMember();
  const { data: teamMembers } = useTeamMembers();
  const [selectedTimePeriod, setSelectedTimePeriod] =
    useState<BaseDropdownOption>(individualViewTimePeriodOptions[0]);

  return (
    <div className="space-y-6 mt-6">
      <div className="flex items-center gap-4">
        <div className="w-80">
          <IndividualViewDropdown
            selectedTimePeriod={selectedTimePeriod}
            setSelectedTimePeriod={setSelectedTimePeriod}
          />
        </div>
        <TeamMemberSelector
          selectedMemberId={selectedMember?.id || null}
          onMemberSelect={(memberId) => {
            const member = teamMembers?.find((m) => m.id === memberId) || null;
            setSelectedMember(member);
          }}
        />
      </div>

      {selectedMember ? (
        <div className="space-y-4">
          <h1 className="text-xl font-normal leading-7 text-[#141414] font-nunito">
            {selectedMember.firstName} {selectedMember.lastName}&apos;s
            Dashboard
          </h1>
          <SprintTimeline selectedTimePeriod={selectedTimePeriod} />
        </div>
      ) : (
        <div className="text-center text-gray-500 py-8">
          Please select a team member to view their performance
        </div>
      )}
    </div>
  );
}

export function IndividualView(): JSX.Element {
  return (
    <SprintProvider>
      <SelectedMemberProvider>
        <IndividualViewContent />
      </SelectedMemberProvider>
    </SprintProvider>
  );
}
